/**
 * Admin Hub Dashboard Component
 * Landing page with quick stats, favorites, and recent items
 */
import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import { AdminHubQuickStats } from './AdminHubQuickStats';
import { AdminHubFavorites } from './AdminHubFavorites';
import { AdminHubRecents } from './AdminHubRecents';

export const AdminHubDashboard: React.FC = () => {
  return (
    <Box>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom fontWeight={600}>
          Admin Hub
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Welcome to the centralized administration dashboard. Access all admin functions from here.
        </Typography>
      </Box>

      {/* Quick Stats */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom fontWeight={500}>
          Quick Stats
        </Typography>
        <AdminHubQuickStats />
      </Box>

      {/* Two-column layout for favorites and recents */}
      <Grid container spacing={3}>
        {/* Favorites */}
        <Grid item xs={12} md={6}>
          <Paper
            variant="outlined"
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: 'background.paper',
            }}
          >
            <AdminHubFavorites />
          </Paper>
        </Grid>

        {/* Recent Items */}
        <Grid item xs={12} md={6}>
          <Paper
            variant="outlined"
            sx={{
              p: 3,
              height: '100%',
              backgroundColor: 'background.paper',
            }}
          >
            <AdminHubRecents />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdminHubDashboard;
